import { useCallback, useMemo } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { Button } from '../button/button.component';
import { trackBreadcrumbNavigation } from '../../utils/analytics/use-navigation-menu-tracking';
import { isHomePage } from '../../utils/strings';

import { BreadcrumbItemModel, BreadcrumbProps } from './breadcrumb.config';

const Breadcrumb = ({ items }: BreadcrumbProps) => {
  const { t } = useTranslation();
  const filteredItems = useMemo(() => items?.filter((_, index) => !index || index >= items.length - 2), [items]);

  const getTitle = useCallback(
    (item: BreadcrumbItemModel) => (isHomePage(item.link.url) ? t('home_page') : item.title),
    [t]
  );

  const onItemClick = (item: BreadcrumbItemModel) => {
    if (!item.active) {
      trackBreadcrumbNavigation({ title: getTitle(item), url: item.link.url });
    }
  };

  return (
    <div className="snowflake-breadcrumb" data-testid="snowflake-breadcrumb">
      <Swiper className="snowflake-breadcrumb-swiper" slidesPerView="auto">
        {filteredItems.map((item, index) => (
          <SwiperSlide
            data-testid="snowflake-breadcrumb-swiper-slider"
            className="snowflake-breadcrumb-swiper-slider"
            key={item.link.url}
          >
            <div className={classNames('snowflake-button-link', { 'snowflake-button-blue': !item.active })}>
              <Button
                className={classNames('snowflake-breadcrumb-item', {
                  'snowflake-breadcrumb-item-active': item.active,
                  'snowflake-breadcrumb-item-hidden-current-page': !item.active && index === filteredItems.length - 1,
                })}
                isLink
                text={getTitle(item)}
                buttonLink={item.link}
                disableAnchor={item.active}
                onClick={() => onItemClick(item)}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Breadcrumb;
